import { StoryId, StorySceneId } from "../../../../models/Story"

export const NEXT_STORY_SCENE = 'NEXT_STORY_SCENE'
export const PREV_STORY_SCENE = 'PREV_STORY_SCENE'
export const SEEN_STORY_SCENE = 'SEEN_STORY_SCENE'

export interface NextStorySceneAction {
    type: typeof NEXT_STORY_SCENE
}

export const nextStoryScene = (): NextStorySceneAction => ({
    type: NEXT_STORY_SCENE,
})

export interface PrevStorySceneAction {
    type: typeof PREV_STORY_SCENE
}

export const prevStoryScene = (): PrevStorySceneAction => ({
    type: PREV_STORY_SCENE,
})

export interface SeenStorySceneAction {
    type: typeof SEEN_STORY_SCENE
    storyId: StoryId
    sceneId: StorySceneId
}

export const seenStoryScene = (storyId: StoryId, sceneId: StorySceneId) => ({
    type: SEEN_STORY_SCENE,
    storyId,
    sceneId
})

export type ScenesActions = NextStorySceneAction | PrevStorySceneAction | SeenStorySceneAction